/* eslint-disable no-unused-vars */
import React from "react";
import HeroBgAnimation from "../HeroBgAnimation";
import Typewriter from "typewriter-effect";
import { Bio } from "../../data/constants";
import {
  HeroContainer,
  HeroBg,
  HeroLeftContainer,
  Img,
  HeroRightContainer,
  HeroInnerContainer,
  TextLoop,
  Title,
  Span,
  SubTitle,
  SocialMediaIcons,
  SocialMediaIcon,
  ResumeButton,
} from "./HeroStyle";

// ── Constants ────────────────────────────────────────────────
const HERO_IMAGE_URL =
  "https://res.cloudinary.com/dpb7crcko/image/upload/f_auto,q_auto,w_500/v1773775685/HeroImage_jiskk6.png";

const TYPEWRITER_CONFIG = {
  strings: Bio.roles,
  autoStart: true,
  loop: true,
};

// ── Sub-components ───────────────────────────────────────────
const HeroLeft = () => (
  <HeroLeftContainer id="Left">
    <Title>
      Hi, I am <br /> {Bio.name}
    </Title>

    <TextLoop>
      I am a
      <Span>
        <Typewriter options={TYPEWRITER_CONFIG} />
      </Span>
    </TextLoop>

    <SubTitle>{Bio.description}</SubTitle>

    <ResumeButton href={Bio.resume} target="_blank" rel="noopener noreferrer">
      Check Resume
    </ResumeButton>
  </HeroLeftContainer>
);

const HeroRight = () => (
  <HeroRightContainer id="Right">
    <Img src={HERO_IMAGE_URL} alt={`${Bio.name} - Hero Image`} />
  </HeroRightContainer>
);

// ── Main Component ───────────────────────────────────────────
const HeroSection = () => (
  <div id="about">
    <HeroContainer>
      <HeroBg>
        <HeroBgAnimation />
      </HeroBg>

      <HeroInnerContainer>
        <HeroLeft />
        <HeroRight />
      </HeroInnerContainer>
    </HeroContainer>
  </div>
);

export default HeroSection;
